import { 
    FriendsListAction, 
    FriendsListActionType, 
    LoadFriendsListFailedAction, 
    LoadFriendsListSucceededAction, 
    SearchFriendsListFailedAction,
    SearchFriendsListSucceededAction,
    SendFriendRequestSucceededAction
} from './friendList.actions';
import { FriendsListState, FRIENDS_LIST_INIT_STATE } from './friendList.state';
import { FriendRequestStatusType } from '../../firebase/friendRequests.service';

export function friendsListReducer(state: FriendsListState = FRIENDS_LIST_INIT_STATE, action: FriendsListAction): FriendsListState {
    switch (action.type) {
        case FriendsListActionType.LOAD_FRIENDS_LIST: {
            return { 
                ...state, 
                isReady             : false,
                isSearchFinished    : false,
                friends             : null, 
                error               : null
            };
        }
        case FriendsListActionType.LOAD_FRIENDS_LIST_FAILED: {
            return { 
                ...state,  
                isReady             : true,
                isSearchFinished    : false,
                friends             : null, 
                error               : (<LoadFriendsListFailedAction>action.error)
            };
        }
        case FriendsListActionType.LOAD_FRIENDS_LIST_SUCCEEDED: {
            return { 
                ...state,   
                isReady             : true,
                isSearchFinished    : false,
                friends             : (<LoadFriendsListSucceededAction>action).friends, 
                error               : null
            };
        }
        case FriendsListActionType.SEARCH_FRIENDS_LIST: {
            return { 
                ...state,         
                isSearchFinished    : false,
                error               : null
            };
        }
        case FriendsListActionType.SEARCH_FRIENDS_LIST_FAILED: {
            return { 
                ...state, 
                isSearchFinished    : true,
                friends             : null, 
                error               : (<SearchFriendsListFailedAction>action.error)
            };
        }
        case FriendsListActionType.SEARCH_FRIENDS_LIST_SUCCEEDED: {
            return { 
                ...state, 
                isSearchFinished    : true,
                friends             : (<SearchFriendsListSucceededAction>action).friends, 
                error               : null
            };
        }
        case FriendsListActionType.SEND_FRIEND_REQUEST_SUCCEEDED: {
            let userID = (<SendFriendRequestSucceededAction>action).userID;
            const nextState = JSON.parse(JSON.stringify(state));
            // Modify the user's status to Pending who I sent friend request to
            for (var friend of nextState.friends) {
                if (friend.uid === userID) {
                    friend.status = FriendRequestStatusType.PENDING;
                }
            };
            return  nextState;
        }
        default:
            return state;
    }
}
